import { render, staticRenderFns } from "./InvoiceDetailsTab.vue?vue&type=template&id=2cb65518&scoped=true&"
import script from "./InvoiceDetailsTab.vue?vue&type=script&lang=js&"
export * from "./InvoiceDetailsTab.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceDetailsTab.vue?vue&type=style&index=0&id=2cb65518&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb65518",
  null
  
)

export default component.exports